import styled from 'styled-components';
import { hiddenMixin, buttonMixin } from 'core/ui/mixins';

export const Button = styled.button`
  ${buttonMixin}
  ${hiddenMixin}
`;

export default Button;
